const RouteFallback = () => (
    <div className="card cash-register-card flex-grow-1">
        <div className="card-main-content d-flex flex-column h-100 pb-2"></div>
        <div className="multi-step-process-box"></div>
    </div>
);

export default RouteFallback;
